import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from 'react-autocomplete';

/*
    Location Search Bar, used in the StoreSearchForm.es6 file
*/
class LocationSearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: ''
        };
    }

    render() {
        return (
            <div className="LocationSearchBar">
                <button
                    className="button LocationSearchBar__locationSearch"
                    onClick={this.props.onClickCurrentHandler}
                    title={this.props.findByCurrentLocationTitle}
                    aria-label={this.props.findByCurrentLocationTitle}
                    type="button"
                />
                <label htmlFor="LocationSearchBar__input" className="show-for-sr">
                    {this.props.inputLabelText}
                </label>
                <Autocomplete
                    ref={this.props.searchInputRef}
                    wrapperStyle={{ position: 'relative', flex: 'auto', display: 'flex' }}
                    items={this.props.storesJSONData}
                    inputProps={{
                        type: 'text',
                        name: this.state.value ? this.props.inputFieldName : '',
                        placeholder: this.props.inputFieldPlaceholder,
                        value: this.state.value,
                        id: 'LocationSearchBar__input'
                    }}
                    shouldItemRender={(item, value) =>
                        value.length > 1 &&
                        item.label.toLowerCase().indexOf(value.toLowerCase()) > -1
                    }
                    getItemValue={item => item.label}
                    renderMenu={children => (
                        <div className="LocationSearchBar__AutocompleteMenu">
                            {children}
                        </div>
                    )}
                    renderItem={(item, isHighlighted) => (
                        <div
                            className={`LocationSearchBar__AutocompleteItem ${
                                isHighlighted
                                    ? 'LocationSearchBar__AutocompleteItem--highlighted'
                                    : ''
                            }`}
                        >
                            {item.label}
                        </div>
                    )}
                    value={this.state.value}
                    onChange={e => this.setState({ value: e.target.value })}
                    onSelect={value => this.setState({ value })}
                />
                <button
                    className="button LocationSearchBar__magnifyingSearch"
                    type="submit"
                    aria-label={this.props.findByAddressTitle}
                />
            </div>
        );
    }
}

LocationSearchBar.propTypes = {
    findByCurrentLocationTitle: PropTypes.string,
    findByAddressTitle: PropTypes.string,
    onClickCurrentHandler: PropTypes.func,
    inputFieldName: PropTypes.string,
    inputFieldPlaceholder: PropTypes.string,
    inputLabelText: PropTypes.string,
    inputFieldChangeHandler: PropTypes.func,
    storesJSONData: PropTypes.array,
    searchInputRef: PropTypes.object
};

export default LocationSearchBar;
